const safeGetData = (path: string, root?: any): any => {
    if (!root) {
        return {};
    }
    const pathArray = path.split('.');
    const property = root[pathArray[0]];

    if (pathArray.length > 1 && property) {
        const newRoot = root[pathArray.shift()!];
        const newPath = pathArray.join('.');

        return safeGetData(newPath, newRoot);
    }

    return property;
};

const getClientData = (path: string) => safeGetData(path, (window as any).clientData);

export { getClientData, safeGetData };

export function safeSetData(object: any, path: string, value: any): any {
    if (object === null || object === undefined) {
        return object;
    }

    const pathArray = toPath(path);
    const length = pathArray.length;
    const lastIndex = length - 1;

    let current = object as Record<string | number, any>;

    for (let i = 0; i < length; i++) {
        const key = pathArray[i];
        const nextKey = pathArray[i + 1];
        const isLast = i === lastIndex;

        if (!isLast && (current[key] === null || current[key] === undefined)) {
            current[key] = isIndex(nextKey) ? [] : {};
        }

        if (isLast) {
            current[key] = value;
        } else {
            current = current[key];
        }
    }

    return object;
}

function toPath(path: string): Array<string | number> {
    const pathMatch = /([^.[\]]+)|(\d+)|(\[(?:'([^']+)'|"([^"]+)")\])/g;
    const result: Array<string | number> = [];
    let match;

    while ((match = pathMatch.exec(path)) !== null) {
        if (match[1]) {
            result.push(match[1]);
        } else if (match[2]) {
            result.push(Number(match[2]));
        } else if (match[4] || match[5]) {
            result.push(match[4] || match[5]);
        }
    }

    return result;
}

function isIndex(key: string | number): boolean {
    return typeof key === 'number' || /^\d+$/.test(key.toString());
}

